export default __webpack_public_path__ + "static/employee_directory-af8b98d975f30f20eedf1e00d2052407.png";